import { render, staticRenderFns } from "./HistorialArmasDialogComponent.vue?vue&type=template&id=4e2ff840"
import script from "./HistorialArmasDialogComponent.vue?vue&type=script&lang=js"
export * from "./HistorialArmasDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports